import { TAG_CONST, TagProps } from './Tag.d';
import { TagColor } from './Tag.styles';

export const Tag = ({ children, variant = 'primary', ...rest }: TagProps) => (
  <TagColor
    data-children={children}
    data-testid={TAG_CONST.TEST_ID}
    data-variant={variant}
    {...rest}
  >
    {children}
  </TagColor>
);

export default Tag;
